import { render, staticRenderFns } from "./PartsUsed.vue?vue&type=template&id=c2b0e4b4&"
import script from "./PartsUsed.vue?vue&type=script&lang=js&"
export * from "./PartsUsed.vue?vue&type=script&lang=js&"
import style0 from "./PartsUsed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports